export default "__VITE_PUBLIC_ASSET__f3ff9b55__"